module.exports = __webpack_public_path__ + "img/eintracht-frankfurt.bf337f08.png";